import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nombreDestino: "",
  codigoDestino: "",
};

const nombredestinoSlice = createSlice({
  name: "nombredestino",
  initialState: initialState,
  reducers: {
    ObtenerNombreDestino: (state, actions) => {
      state.nombreDestino = actions.payload.nombreDestino;
      state.codigoDestino = actions.payload.codigoDestino;
    },

    CleanNombreDestino: (state) => {
      state.nombreDestino = "";
      state.codigoDestino = "";
    },
  },
});

export const { ObtenerNombreDestino, CleanNombreDestino } = nombredestinoSlice.actions;

export default nombredestinoSlice.reducer;